import {type SVGProps, forwardRef} from 'react';

export const NoiseReductionIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            d='M10 2C10.5523 2 11 2.44772 11 3V21C11 21.5523 10.5523 22 10 22C9.44772 22 9 21.5523 9 21V3C9 2.44772 9.44772 2 10 2Z'
            fill='currentColor'
        />
        <path
            d='M18 5C18.5177 5 18.9438 5.39333 18.9951 5.89746L19 6V18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18V6L17.0049 5.89746C17.0562 5.39333 17.4823 5 18 5Z'
            fill='currentColor'
        />
        <path
            d='M6 6C6.51768 6 6.94379 6.39333 6.99512 6.89746L7 7V17C7 17.5523 6.55228 18 6 18C5.44772 18 5 17.5523 5 17V7L5.00488 6.89746C5.05621 6.39333 5.48232 6 6 6Z'
            fill='currentColor'
        />
        <path
            d='M14 7C14.5177 7 14.9438 7.39333 14.9951 7.89746L15 8V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V8L13.0049 7.89746C13.0562 7.39333 13.4823 7 14 7Z'
            fill='currentColor'
        />
    </svg>
));
